/*
|--------------------------------------------------------------------------
| WOW ANIMATIONS
|--------------------------------------------------------------------------
*/
var wow = new WOW ({
	offset: 75,
	mobile: false
}).init();


/*
|--------------------------------------------------------------------------
| Welcome Section Slider
|--------------------------------------------------------------------------
*/
$(function() {

	var Page = (function() {

		var $navArrows = $( '#nav-arrows' ),
			$nav = $( '#nav-dots > span' ),
			slitslider = $( '#slider' ).slitslider( {
				onBeforeChange : function( slide, pos ) {

					$nav.removeClass( 'nav-dot-current' );
					$nav.eq( pos ).addClass( 'nav-dot-current' );

				}
			} ),

			init = function() {

				initEvents();

			},
			initEvents = function() {

				// add navigation events
				$navArrows.children( ':last' ).on( 'click', function() {

					slitslider.next();
					return false;

				} );

				$navArrows.children( ':first' ).on( 'click', function() {

					slitslider.previous();
					return false;

				} );

				$nav.each( function( i ) {

					$( this ).on( 'click', function( event ) {

						var $dot = $( this );

						if( !slitslider.isActive() ) {

							$nav.removeClass( 'nav-dot-current' );
							$dot.addClass( 'nav-dot-current' );

						}

						slitslider.jump( i + 1 );
						return false;

					} );

				} );

			};

		return { init : init };

	})();

	Page.init();

});


(function(){

	jQuery('.datepicker').datepicker({
		format: 'yyyy-mm-dd',
		autoclose: true,
		todayHighlight: true
	});
	
    //$('.collapse').collapse(toggle);
	sweetAlertInitialize();

    $('.pop').on('hidden.bs.popover', function () {
        $('#courseMenu').popover('toggle');
    });

	$('input').iCheck({
		checkboxClass: 'icheckbox_flat-blue',
		radioClass: 'iradio_flat-blue',
		increaseArea: '-10%' // optional
	});

    $('#dropdownAccount').click('show.bs.dropdown', function () {
        $('.dropdown-menu').animate({
            opacity: '1'
        });
    });
	
	/*
	|--------------------------------------------------------------------------
	| Menu item highlighting
	|--------------------------------------------------------------------------
	*/
	jQuery('#nav').singlePageNav({
		offset: jQuery('#nav').outerHeight(),
		filter: ':not(.external)',
		speed: 2000,
		currentClass: 'current',
		easing: 'easeInOutExpo',
		updateHash: true,
		beforeStart: function() {
			console.log('begin scrolling');
		},
		onComplete: function() {
			console.log('done scrolling');
		}
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() > 400) {
			$(".navbar-brand a").css("color","#fff");
			$("#navigation").removeClass("animated-header");
		} else {
			$(".navbar-brand a").css("color","inherit");
			$("#navigation").addClass("animated-header");
		}
	});

	/*
	|--------------------------------------------------------------------------
	| Fix Slider Height
	|--------------------------------------------------------------------------
	*/
	var slideHeight = $(window).height();

	$('#home-slider, #slider, .sl-slider, .sl-content-wrapper').css('height',slideHeight);

	$(window).resize(function(){'use strict',
		$('#home-slider, #slider, .sl-slider, .sl-content-wrapper').css('height',slideHeight);
	});
	
	$("#works, #testimonial").owlCarousel({
		navigation : true,
		pagination : false,
		slideSpeed : 700,
		paginationSpeed : 400,
		singleItem:true,
		navigationText: ["<i class='fa fa-angle-left fa-lg'></i>","<i class='fa fa-angle-right fa-lg'></i>"]
	});



	$(".select2").select2();

		/*
	|--------------------------------------------------------------------------
	| NAVABAR open/close
	|--------------------------------------------------------------------------
	*/

    $(document).ready(function() {
        $( "div.fixed-ad-well" ).hide();
        $( "a.fixed-ad-links" ).on( "click", function() {
            $( "div.fixed-ad-well" ).slideToggle( "slow", function() {
            });
        });
    });
        


})();